var render = function render(){var _vm=this,_c=_vm._self._c;return _c('splide',{staticClass:"splide--container",attrs:{"options":_vm.options}},_vm._l((_vm.slides),function(item){return _c('splide-slide',{key:item.id,staticClass:"splide--container__slide"},[_c('ResponsiveImage',{attrs:{"src":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }